// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","SellerReviews__selfBlocked":"gs_a bhe_cw bhe_tu bhe_sm bhe_ug bhe_ua"};